import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { RootState } from '../../Redux/Store';
import { getStoredMemberships } from '../../Redux/Auth/authApi';

/**
 * 全認証画面共通のフッター（SessionGuard から一括描画）。
 * 1行目: ログイン中の企業名・店舗名 / 2行目: コピーライト + サービス名。
 * ページ末尾の余白（pb）もここで確保する。
 */
const ServiceFooter: React.FC = () => {
  const companyName = useSelector((state: RootState) => state.company.name);
  const currentStoreId = localStorage.getItem('store_id') ?? '';
  const storeName = getStoredMemberships().find((m) => m.storeId === currentStoreId)?.storeName;

  return (
    <Box
      component="footer"
      sx={{
        pt: 4,
        pb: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.25,
        textAlign: 'center',
      }}
    >
      {(companyName || storeName) && (
        <Typography variant="caption" color="text.secondary">
          {[companyName, storeName].filter(Boolean).join(' ')}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary">
        ©FEAST株式会社 FEAST 店内オーダー・予約管理システム
      </Typography>
    </Box>
  );
};

export default ServiceFooter;
